// Returns the parsed currentUser by checking pendingLogin's isRememberMe flag
export default function removeCurrentUser() {
  try {
    const isRememberMe = localStorage.getItem("isRememberMe") === "true";
    const storage = isRememberMe ? localStorage : sessionStorage;
    const raw = storage.getItem("currentUser");
    storage.removeItem("currentUser");
    return raw ? JSON.parse(raw) : null;
  } catch (e) {
    console.error("removeCurrentUser error", e);
    return null;
  }
}
